import classnames from "classnames"
import parse from "html-react-parser"

import { formatHexColorValue } from "shared/lib/alternate_brand_color"

import pauseIcon from "images/icons/pause.svg?raw"
import chevronIcon from "images/icons/chevron-right.svg?raw"

import styles from "./paused_chip.module.scss"

interface Props {
  brandColor: string
  // A link when it has a destination, else a button that runs onClick.
  href?: string
  onClick?: () => void
  className?: string
}

// Figma 1818-319795: the brand color 20% darker, for every brand. The paused card is the brand
// color lighter, so the chip stands out from it on dark brands too.
export const chipBackground = (brandColor: string) => {
  const layer = "rgba(17, 17, 17, 0.2)"
  return `linear-gradient(${layer}, ${layer}), ${formatHexColorValue(brandColor)}`
}

// Takes the place of the connect button while IFE pauses the user's runs. The card is a link
// to the Applet, so the chip is a sibling control placed over the space the card keeps for it.
export default function PausedChip({ brandColor, href, onClick, className }: Props) {
  const props = {
    className: classnames(styles["paused-chip"], className),
    style: { background: chipBackground(brandColor) },
  }
  const content = (
    <>
      <span className={styles.icon}>{parse(pauseIcon)}</span>
      <span className={`body-caption ${styles.label}`}>Paused - no credits left to run</span>
      <span className={styles.icon}>{parse(chevronIcon)}</span>
    </>
  )

  return href ? (
    <a href={href} {...props}>
      {content}
    </a>
  ) : (
    <button type="button" onClick={onClick} {...props}>
      {content}
    </button>
  )
}

export const PausedChipSpace = () => <div className={styles.space} aria-hidden="true" />
